import { Shield, Phone, CheckCircle2 } from 'lucide-react';
import ContactForm from '../../components/ContactForm';
import SEO from '../../components/SEO';

export default function ServiceEn() {
  const servicePunkter = [
    'Flexible agreement: Choose either a 6- or 12-month service contract',
    'Comprehensive inspection of your Danshaker from A to Z',
    'Deep cleaning and touch-up paint repairs where required',
    'Cleaning and lubrication of all moving components and mechanical bearings',
    'If any parts need replacement, we consult you first with transparent pricing before initiating work.'
  ];

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Service Agreement - Keep Your Danshaker in Peak Condition"
        description="Book a service contract for your Danshaker for only 995 DKK excl. VAT. Comprehensive check-up, lubrication, and maintenance from A to Z."
        path="/en/service"
        lang="en"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Main Content */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-20 md:px-8 md:pt-24">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-start">
          {/* Left Column: Info */}
          <div className="lg:col-span-6 space-y-8 lg:sticky lg:top-40">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
                <Shield className="h-3.5 w-3.5" aria-hidden="true" />
                <span>Keep your machine in peak condition</span>
              </div>
              <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
                Service Agreement
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed">
                Danshaker offers an attractive service contract – choose either a 6- or 12-month interval to ensure your machine operates reliably and delivers maximum service life for years to come.
              </p>
            </div>

            {/* Price Box */}
            <div className="rounded-2xl border border-slate-200 bg-white p-6 space-y-2 shadow-xl">
              <span className="block text-xs text-slate-500 font-semibold uppercase tracking-wider">Service agreement fee</span>
              <div className="flex items-baseline gap-2">
                <span className="text-3xl font-black text-[#0E67A2]">995 DKK</span>
                <span className="text-sm text-slate-500 font-semibold">excl. VAT *</span>
              </div>
              <p className="text-xs text-slate-400 font-semibold italic border-t border-slate-100 pt-2 mt-2">
                * Parts, lubricants, and potential transport costs are billed separately.
              </p>
            </div>

            {/* Service Checkpoints */}
            <div className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900">What does the service include?</h2>
              <ul className="space-y-3 text-slate-700">
                {servicePunkter.map((punkt, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-sm font-medium">
                    <CheckCircle2 className="h-5 w-5 text-[#0E67A2] shrink-0 mt-0.5" />
                    <span>{punkt}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact callout */}
            <div className="rounded-2xl bg-slate-900 p-6 text-white space-y-4 shadow-xl">
              <h3 className="font-bold text-lg">Do you have technical questions?</h3>
              <p className="text-slate-300 text-sm">
                Call Rasmus directly at +45 2530 3589 or write to us for maintenance questions.
              </p>
              <a
                href="tel:25303589"
                className="inline-flex items-center gap-2 rounded-xl bg-[#0E67A2] px-5 py-2.5 text-sm font-bold text-white transition hover:bg-[#0E67A2]/90 shadow-md"
              >
                <Phone className="h-4 w-4" />
                Call +45 2530 3589
              </a>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="lg:col-span-6">
            <div className="rounded-3xl border border-slate-200 bg-white p-6 md:p-10 shadow-2xl">
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900">Book service</h2>
                <p className="mt-1 text-sm text-slate-500 font-medium">
                  Submit your details below and we will contact you to schedule an inspection date.
                </p>
              </div>

              <ContactForm
                source="Serviceaftale"
                defaultService="Serviceaftale til Danshaker"
                buttonText="Request service appointment"
                lang="en"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
